// extracted by mini-css-extract-plugin
module.exports = {"listContainer":"verificationDialog_listContainer__3WcGX"};